import { createReducer } from 'store/createReducer';
import { CustomerPageModel } from 'models/CustomerPageModel';
import { CustomerPageSection } from 'models/CustomerPageSection';
import {
  CUSTOMERPAGE_LOGOUT,
  CUSTOMERPAGE_RETURN,
  CUSTOMERPAGE_RETURN_COMPLETE,
  CUSTOMERPAGE_ORDERHISTORY,
  CUSTOMERPAGE_DELIVERIES_COMPLETE,
  CUSTOMERPAGE_CHANGE_COMPLETE,
  CUSTOMERPAGE_CLAIMS_COMPLETE,
  ReturnAction,
  CUSTOMERPAGE_SHIPPING_DAMAGE_COMPLETE,
  CUSTOMERPAGE_PRICE_MATCH_COMPLETE
} from './actions';
import initialPageState from 'components/Pagelayout/initialPageState';

const Reducer = {
  [CUSTOMERPAGE_LOGOUT]: (state: CustomerPageModel) => {
    return {
      ...state,
      section: CustomerPageSection.Login,
      customer: undefined
    };
  },
  [CUSTOMERPAGE_RETURN]: (state: CustomerPageModel, action: ReturnAction) => {
    return {
      ...state,
      section: CustomerPageSection.Return,
      returnOrder: action.order
    };
  },
  [CUSTOMERPAGE_RETURN_COMPLETE]: (state: CustomerPageModel) => {
    return {
      ...state,
      section: CustomerPageSection.ReturnComplete
    };
  },
  [CUSTOMERPAGE_PRICE_MATCH_COMPLETE]: (state: CustomerPageModel) => {
    return {
      ...state,
      section: CustomerPageSection.PriceMatchComplete
    };
  },
  [CUSTOMERPAGE_CHANGE_COMPLETE]: (state: CustomerPageModel) => {
    return {
      ...state,
      section: CustomerPageSection.ChangesComplete
    };
  },
  [CUSTOMERPAGE_CLAIMS_COMPLETE]: (state: CustomerPageModel) => {
    return {
      ...state,
      section: CustomerPageSection.ClaimsComplete
    };
  },
  [CUSTOMERPAGE_ORDERHISTORY]: (state: CustomerPageModel) => {
    return {
      ...state,
      section: CustomerPageSection.OrderHistory
    };
  },
  [CUSTOMERPAGE_DELIVERIES_COMPLETE]: (state: CustomerPageModel) => {
    return {
      ...state,
      section: CustomerPageSection.DeliveriesComplete
    };
  },
  [CUSTOMERPAGE_SHIPPING_DAMAGE_COMPLETE]: (state: CustomerPageModel) => {
    return {
      ...state,
      section: CustomerPageSection.ShippingDamageComplete
    };
  }
};

export const initialState: CustomerPageModel = {
  ...initialPageState,
  menuItems: [],
  loginPageMenuItems: [],
  section: CustomerPageSection.Unknown,
  loginPage: '',
  returnsPageUrl: '',
  claimsPageUrl: '',
  deliveryPageUrl: '',
  paymentPageUrl: ''
};

export default createReducer(initialState, Reducer);
